import { Box } from '@chakra-ui/react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

function Calendar({ events, onClickTimeLine, ...rest }) {
  const handleDateClick = (info) => {
    onClickTimeLine(info.dateStr);
  };
  // const handleEventDidMount = (info) => {
  //   const element = info.el;
  //   element.addEventListener('mouseenter', () => {
  //     const title = info.event.title;
  //     const rect = element.getBoundingClientRect();
  //     const x = rect.left + window.pageXOffset;
  //     const y = rect.top + window.pageYOffset - 30; // Sesuaikan dengan posisi yang diinginkan

  //     const hoverBox = document.createElement('div');
  //     hoverBox.style.position = 'absolute';
  //     hoverBox.style.left = `${x}px`;
  //     hoverBox.style.top = `${y}px`;
  //     hoverBox.style.backgroundColor = 'gray';
  //     hoverBox.style.padding = '8px';
  //     hoverBox.textContent = title;
  //     hoverBox.style.zIndex = 100;

  //     document.body.appendChild(hoverBox);

  //     element.addEventListener('mouseleave', () => {
  //       document.body.removeChild(hoverBox);
  //     });
  //   });
  // };

  return (
    <Box bgColor="white">
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        events={events}
        // eventDidMount={handleEventDidMount}
        eventClick={handleDateClick}
        {...rest}
      />
    </Box>
  );
}

Calendar.defaultProps = {
  events: [],
};

export default Calendar;
